module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre_15",
    attrs: {
      "id": "filepos21401"
    }
  }, [_c('span', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "italic1"
  }, [_c('a', {
    staticClass: "calibre8"
  }), _vm._v("Contents")])])]), _c('div', {
    staticClass: "calibre_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre_7"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/index_split_007#filepos51581"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Title of This Book")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_7"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/index_split_008#filepos54843"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Preface")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_7"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/index_split_009#filepos57248"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Prolegomenon")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_7"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/index_split_011#filepos59565"
    }
  }, [_vm._v("1. Revaluation of Values: Three False Values")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/index_split_012#filepos62236"
    }
  }, [_vm._v("2. Buddhas for Burning")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/index_split_013#filepos64620"
    }
  }, [_vm._v("3. Man Is a River")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/index_split_014#filepos65673"
    }
  }, [_vm._v("4. Time and Movement Are Two Aspects of a Single Phenomenon")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/index_split_014#filepos65875"
    }
  }, [_vm._v("Portrait of a Gentleman")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/index_split_015#filepos67077"
    }
  }, [_vm._v("5. Living Backwards")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/index_split_016#filepos69765"
    }
  }, [_vm._v("6. Policemen Disguising Themselves as Thieves in Order to Catch Themselves")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/index_split_016#filepos70869"
    }
  }, [_vm._v("Armchair Travelling")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/index_split_017#filepos71428"
    }
  }, [_vm._v("7. Le Fantoche")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/index_split_018#filepos73149"
    }
  }, [_vm._v("8. Free-will Versus Determinism")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/index_split_019#filepos76212"
    }
  }, [_vm._v("9. Free-will - I")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/index_split_019#filepos77296"
    }
  }, [_vm._v("Free-will - II")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/index_split_020#filepos77846"
    }
  }, [_vm._v("10. Freedom - I")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/index_split_020#filepos79070"
    }
  }, [_vm._v("Freedom - II")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "href": "#/index_split_021#filepos80869"
    }
  }, [_vm._v("11. Débris - I")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_022#filepos83310",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Turning the Other Cheek")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_022#filepos84115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poached Eggs (all of us)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_023#filepos86295",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Group Egoism—A Causerie")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_024#filepos88529",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Travail")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_024#filepos89513",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dream Figures. “As Below...”")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_025#filepos90612",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. The Man in the Moon")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_026#filepos92680",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. You Must Dig Deep to Bury Your Shadow—A Causerie")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_027#filepos95088",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. The Reason")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_028#filepos96813",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Definitions - I")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('a'), _c('span', {
    attrs: {
      "href": "#/index_split_029#filepos99079",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. The Great Joke")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_030#filepos101187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. Definitions of Non-attachment")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_031#filepos102505",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. Booing the Villain")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_031#filepos103624",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cock-a-doodle-do")])])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_031#filepos104278",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Artichoke—Ecstasis")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_032#filepos105079",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. Integration")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_033#filepos109392",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. Débris - II")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_033#filepos111136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Eye")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_034#filepos112795",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24. Pure Consciousness")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_034#filepos113825",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tao")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_035#filepos116955",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25. Transcending Space")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_035#filepos118166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dualism Is a Function of Tridimensionality")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_036#filepos118804",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26. Transcending Time")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_037#filepos120661",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27. The Dreamer")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_037#filepos120819",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_037#filepos127998",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_037#filepos133080",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_038#filepos136077",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28. Uncommon-Sense Regarding Reincarnation")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_039#filepos138175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29. Unicity - I")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_039#filepos139009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unicity - II")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_040#filepos140205",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30. Good Morning")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_041#filepos154238",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31. The House of Cards")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_041#filepos154403",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_041#filepos157167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_042#filepos160256",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32. Dreams and Reality")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_043#filepos161935",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33. Free-will - III")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_044#filepos163652",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34. La Vida Es Sueño")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_045#filepos165491",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35. The One Freedom")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_046#filepos171538",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36. Unicity - III")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_047#filepos174770",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37. The Bogie")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_048#filepos179805",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38. The Three Known Dimensions Are External: The Fourth Is Within the Mind")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_048#filepos180999",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Free-will - IV")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_049#filepos181746",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39. The Present Includes Past and Future")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_050#filepos183828",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40. The Communication of Knowledge and the Communication of Understanding")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('a'), _c('span', {
    attrs: {
      "href": "#/index_split_051#filepos186684",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41. The Spanner")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_052#filepos189172",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42. The Column of Smoke")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_053#filepos192558",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43. Other Aspects of the Dream We Are Living")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_054#filepos197559",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44. To Be or Not To Be")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_055#filepos210696",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45. Kittens in Wool")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_056#filepos212327",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46. Definitions - II")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_057#filepos215268",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47. “L’art Moderne”")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_058#filepos217547",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48. Between Ourselves")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_058#filepos219557",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Questions that Are Not")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_059#filepos220219",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49. Democracy - I")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_059#filepos221767",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Demophily")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_060#filepos223087",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50. Mutt and Jeff")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_061#filepos226200",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51. “Progress”")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_062#filepos228232",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52. Impasse")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_063#filepos231418",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53. The Mind Is a Moon")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_063#filepos232567",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Day of Pseudo-Glory")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_064#filepos234038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54. Karma: A Suggestion")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_064#filepos236354",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Free-will - V")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_065#filepos237000",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55. Dualism Is Duodimensional")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_065#filepos240276",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Time")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_066#filepos241112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56. Débris - III")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_066#filepos243494",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Definitions - III")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_067#filepos244225",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57. Us")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_068#filepos263902",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58. Let It Grow")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_069#filepos265942",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59. The Second Barrier")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_070#filepos269306",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60. Spontaneity - I")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_071#filepos271349",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61. Will - I")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_071#filepos271659",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Will - II")])])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_071#filepos272546",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Will - III")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_072#filepos272984",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62. Seeking for Satori")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_072#filepos273691",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spiritual Experience")])])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_072#filepos274513",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suchness")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_073#filepos275448",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63. There Is No “I” But I—A Causerie")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_073#filepos275627",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_073#filepos279556",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_074#filepos283582",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64. Life: A Definition")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('a'), _c('span', {
    attrs: {
      "href": "#/index_split_075#filepos284183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65. The Opposites and Complementaries")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_076#filepos287803",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66. Subject and Object")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_077#filepos289645",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67. Free-will - VI")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_078#filepos291441",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68. What Am I?")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_079#filepos308808",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69. The Fact of the Matter")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_080#filepos310347",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70. Definition of Spontaneity")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_081#filepos312289",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71. The Last Lap")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_082#filepos325107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72. Enlightenment")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_082#filepos326105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spontaneity - II")])])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_082#filepos326548",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Personalised Deity")])])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_082#filepos327033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Transcending Dualism")])])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_082#filepos327655",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Show A Leg!")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_083#filepos328558",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73. Who Are We?—A Causerie")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_084#filepos334179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74. Absolutely Us")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_084#filepos335191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Old Man in the Corner")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_085#filepos336312",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75. Objects in Duality Are Not Subjects in Duality")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_086#filepos338607",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76. Existing, Not-Existing, or Not Not-Existing? A Somewhat Tedious Discussion")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_087#filepos344006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77. Reintegrating the Subject")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_088#filepos349503",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78. Sense and Non-Sense")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_089#filepos375610",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79. The Dharma")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_090#filepos390637",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80. Hard Words")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_090#filepos390794",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Evasion")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_091#filepos392363",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81. Metaphysical Analysis of What We Are")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_092#filepos396739",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82. A Trilogy")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_092#filepos396895",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Resolving Our Personal Duality - I")])])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_092#filepos398158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The Process of Release")])])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_092#filepos398983",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Infusion")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_093#filepos402660",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83. The Reason Why - I")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_093#filepos403762",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Reason Why - II")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_094#filepos406232",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84. Awakening By Means of the Dream Can Only Be Dreaming that We Are Awake")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_095#filepos408142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85. The Criminal - I")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_096#filepos438518",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86. The Criminal - II")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('a'), _c('span', {
    attrs: {
      "href": "#/index_split_097#filepos452348",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87. Street Scene")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_097#filepos453614",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tinkle-Tinkle")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_098#filepos454413",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88. Resolving Our Personal Duality - II")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_099#filepos459007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89. Geometrical Representation of Our Multidimensional Reality")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_100#filepos462915",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90. The Term “Enlightenment”")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_101#filepos466206",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91. The Essential Explanation - I")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_102#filepos467181",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92. Do We Know How to Read?")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_103#filepos468924",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93. Is It a Concept?")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_104#filepos472340",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94. Quiddity")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_105#filepos476373",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95. Reverence—A Causerie")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_106#filepos479749",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96. Being")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_106#filepos480771",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Homo Sapiens")])])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_106#filepos481194",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Karuna-Caritas")])])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_106#filepos481995",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Present")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_107#filepos482445",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97. The Possibility of Reincarnation")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_108#filepos485892",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98. I Am, or the Ultimate Subject")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_109#filepos489900",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99. Transcendence—What It Is")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_110#filepos491352",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100. The Wrath of God")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_111#filepos494221",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101. Transcendence or Neutralisation?")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_112#filepos496222",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102. Duality or Dualism?")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_112#filepos497123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Personal")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_113#filepos497743",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103. The Essential Explanation - II")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_114#filepos502901",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104. Reincarnation: Ultimate Observation")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_115#filepos509457",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105. The Essential Explanation - III: The Big Black Cloud")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_116#filepos517337",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106. Perception and Reality")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_116#filepos518940",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Direct Cognition")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_117#filepos519843",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107. One Half of a Pair—A Causerie")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_118#filepos529522",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108. Democracy - II")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_118#filepos530978",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ends and Means")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_119#filepos531713",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109. Dusting the Parrot")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_120#filepos553284",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110. Good-bye, Old Man")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_121#filepos556507",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111. Vale")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_7"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_122#filepos557401",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Colophon")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_7"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('a'), _c('span', {
    attrs: {
      "href": "#/index_split_123#filepos558146",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Epilogue")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_123#filepos558264",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Why Lazarus Laughed")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_124#filepos562507",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. What I Am . . .")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_124#filepos563262",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How I Realise What I Am")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_125#filepos565677",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. I Am Not-I . . .")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_126#filepos568338",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Questions that Are Not")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_127#filepos571994",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The Hansom-cab")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_127#filepos573359",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Unwanted Host")])])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_127#filepos574367",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Straight from the Horse’s Mouth")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_128#filepos574687",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Time and Eternity")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_128#filepos575950",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Who Is Sane?")])])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_128#filepos576658",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mind and Matter - I")])])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_128#filepos577446",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mind")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_129#filepos577840",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Phenomenal Reality or the Reality of Phenomena")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_129#filepos579247",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Faith")])])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_129#filepos579475",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Done It")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_130#filepos580570",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. That We Are")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_131#filepos584135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. What “It” Is")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_132#filepos585889",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Whole-Mind")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_133#filepos587493",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Two Is One")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_134#filepos604804",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Karuna: A Reminder")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_135#filepos607267",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. The Essential Explanation - IV: Reunion of Mind")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_135#filepos608454",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Essential Explanation - V")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_136#filepos608838",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. False Premises")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_136#filepos610114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Obiter Dicta")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_137#filepos611787",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Mind and Matter - II: Restatement")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_16"
  }, [_c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_137#filepos616211",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Diagram of Mind and Matter")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_138#filepos617945",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. The Mechanism of Psycho-Kinetic Phenomena")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_139#filepos620663",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Understanding of Zen: The Key that Is The Way")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_140#filepos628568",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Whole-Mind and the Way")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_141#filepos631566",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. The “Doctrine” of Subjectivity")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_142#filepos635080",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. The Binocular Aspect of Subjectivity")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_143#filepos638440",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. Realisation")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_7"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_144#filepos641708",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Envoi")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_7"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/index_split_145#filepos642224",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Index")])])])]), _vm._v(" "), _c('div', {
    staticClass: "mbp_pagebreak",
    attrs: {
      "id": "calibre_pb_8"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5de6564","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_006.vue
// module id = 78
// module chunks = 0